// extracted by mini-css-extract-plugin
export default {"article":"article_article__9CYMz"};